import { Controller } from 'stimulus';

// The Send out sheet (calibration_send_outs/_sheet): Expected back follows the
// provider's usual turnaround and the shipped date, until someone types a
// date of their own.
export default class extends Controller {
  static targets = ['provider', 'shipped', 'expected', 'hint'];

  refresh() {
    const params = new URLSearchParams({ provider_id: this.providerTarget.value, shipped_on: this.shippedTarget.value });
    fetch(`${this.data.get('previewUrl')}?${params}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!data) return;
        this.hintTarget.textContent = data.hint;
        if (!this.expectedTouched) this.expectedTarget.value = data.expected_back || '';
      })
      .catch(() => {});
  }

  expectedChanged() {
    this.expectedTouched = true;
  }
}
